import React, { useContext, useEffect, useState } from "react";
import {
  PaymentElement,
  LinkAuthenticationElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";
import { ToastContainer, toast } from "react-toastify";
import UserContext from "../../UserContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { getDownloadURL, getStorage, ref, uploadString } from "firebase/storage";


export default function CheckoutForm({event,quantity}) {
  const stripe = useStripe();
  const elements = useElements();

  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const {userInfo} = useContext(UserContext);
  const [userData,setUserData] = useState();
  const navigate = useNavigate();

    const getUser = async(id) => {
        const resp = await axios.get(`https://event-finder12.onrender.com/users/getuser/${id}`)
        setUserData(resp.data);
    }


  useEffect(() => {
    if (!stripe) {
      return;
    }

    getUser(userInfo.email);


    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Something went wrong.");
          break;
      }
    });
  }, [stripe]);



  const handleQrUpload = async (qrCodeBase64,ticketID) => {
    const storage = getStorage();
    const file = Date.now() + '.png'
    const storageRef = ref(storage, `tickets/${userInfo.uid}/ticketQR/${file}`);

    try {
      
      await uploadString(storageRef, qrCodeBase64, 'data_url');
      const downloadURL = await getDownloadURL(storageRef);

      console.log(downloadURL)

      const response = await axios.put(`https://event-finder12.onrender.com/ticket/update-qr-url/${ticketID}`,{
        qrURL:downloadURL
      })
      return response.data;

    } catch (error) {
      console.error('Error uploading QR code:', error);
    }
  }

  

  

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      redirect:'if_required'
    });



   if(error) {
    if (error.type === "card_error" || error.type === "validation_error") {
        setMessage(error.message);
        toast.error(error.message)
      } else {
        setMessage("An unexpected error occurred.");
        toast.error("An unexpected error occurred.")
      }
   }
    

   try {
   
    const ticketData = {
      id: event._id, 
      userId: userData._id,
      numberOfTickets: quantity 
    };


   
    const response = await axios.post('https://event-finder12.onrender.com/ticket/createticket', ticketData);
    

    const createdTicket = response.data;

    const updatedTicket = await handleQrUpload(createdTicket.qrCode,createdTicket._id)

    console.log(updatedTicket)


    console.log("Created Ticket:", createdTicket);

    try {
        const mailResponse = await axios.post('https://event-finder12.onrender.com/sendReceipt', {
            userEmail: userData.email,
            ticketCode: createdTicket.ticketCode, 
            qrCode: updatedTicket.qrCode,
            name: userData.displayName
        });
        console.log(mailResponse.data);
    } catch (error) {
        console.error("Failed to send receipt email:", error);
    }

    localStorage.setItem('ticketData', JSON.stringify(createdTicket));
    navigate(`/completion`);
  } catch (error) {
    console.error("Ticket creation failed:", error);
    setMessage("Ticket creation failed.");
    toast.error("Ticket creation failed.");
  }
  

    setIsLoading(false);
  };

  const paymentElementOptions = {
    layout: "tabs"
  }

  return (
    <div>
        <ToastContainer/>
        <form id="payment-form" onSubmit={handleSubmit}>
      <LinkAuthenticationElement
        id="link-authentication-element"
        onChange={(e) => {
            setEmail(e.value.email)
          }}
      />
      <PaymentElement id="payment-element" options={paymentElementOptions} />
      <button  className="pay-button" disabled={isLoading || !stripe || !elements} id="submit">
        <span id="button-text">
          {isLoading ? <div className="spinner" id="spinner"></div> : "Pay now"}
        </span>
      </button>
    </form>
    </div>
    
  );
}